/**
 * ! This component/file or some other components/files that use this component/file is being shared in one or more micro-frontend.
 * ! Please be careful when editing this component. Make sure to run "yarn build:dev" and check if the "build/@types/index.d.ts" file
 * ! is being generated or not without any errors.
 */
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { STYLE } from '../../../../constants/style';

export const useStyles = makeStyles(theme =>
  createStyles({
    loading: {
      backgroundColor: `${STYLE.COLOR.UNCOMPLETED} !important`,

      '& .MuiButton-label': {
        color: STYLE.COLOR.WHITE,
        display: 'flex',
        justifyContent: 'flex-start',
      },

      '& svg': {
        '& g': {
          stroke: STYLE.COLOR.WHITE,
        },
      },
    },
    spinnerWrapper: {
      position: 'relative',
      bottom: '0.5px',
      padding: '0 0.2em',
    },
    textWrapper: {
      display: 'flex',
      justifyContent: 'center',
      width: '90%',
    },
  })
);
